import { ListInitiativeTypes } from './ListInitiativeTypes';

/**
 * queries
 *
 * @type {{ListInitiativeTypes: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  ListInitiativeTypes,
};
